import { selector } from "recoil";

import {
  IPassengerStationsMapInfo,
  PassengersMapStationIdType,
} from "../../models";
import { passengersStationsMapDataAtom } from "../atoms";

export const passengersStationsMapDictionaryDataSelector = selector<
  Map<PassengersMapStationIdType, IPassengerStationsMapInfo>
>({
  key: "passengersStationsMapDictionaryDataSelector",
  get: ({ get }) => {
    const data = get(passengersStationsMapDataAtom);
    return new Map(
      (Array.isArray(data) ? data : [])?.map(s => [s?.stationInfo?.id, s]),
    );
  },
});
